// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgActivity24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M11.7412 7C12.1899 7 12.5537 7.36377 12.5537 7.8125V12.252L15.4424 14.1777C15.7818 14.404 15.8956 14.842 15.7266 15.2002L15.668 15.3047C15.4191 15.678 14.9144 15.779 14.541 15.5303L11.291 13.3633C11.065 13.2126 10.9287 12.9591 10.9287 12.6875V7.8125C10.9287 7.3639 11.2927 7.00021 11.7412 7Z" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.2124 1C18.2875 1 23.2124 5.92487 23.2124 12C23.2124 18.0751 18.2875 23 12.2124 23C6.13727 23 1.2124 18.0751 1.2124 12C1.2124 5.92487 6.13727 1 12.2124 1ZM12.21 2.5C6.96326 2.5 2.70996 6.75329 2.70996 12C2.70996 17.2467 6.96326 21.5 12.21 21.5C17.4567 21.5 21.71 17.2467 21.71 12C21.71 6.75329 17.4567 2.5 12.21 2.5Z"
				/>
			</Svg>
		);
	}
);
SvgActivity24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgActivity24;
